import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const OverflowBox = styled(Box)(() => ({
  overflowX: "hidden",
  overflowY: "scroll",
}));
